// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeekAllDay-modulecorner__Qj7oS";
var _2 = "CalendarGridWeekAllDay-modulelane__NGHa0";
export { _1 as "corner", _2 as "lane" }
